<template>
  <div>
    {{ uniqueId }}<br/>
    {{ name }}
  </div>
</template>

<script>
import infopoint from "@/store/displays/infopoint";
export default {
  name: "InfopointCell",
  data() {
    return {
      id: null,
      name: null,
      uniqueId: null
    };
  },
  props: {
    infopointId: Number
  },
  computed: {
      infopointList() {
          return this.$store.state.infopoint.infopointList;
      }
  },
  mounted() {
    this.$store.dispatch('infopoint/getInfopointList');
  },
  created() {
    if (!this.$store.state.infopoint) {
      this.$store.registerModule("infopoint", infopoint);
    }
    
  } ,
  watch: {
      infopointList: function() { this.updateInfo()  },
      infopointId: function() { this.updateInfo() }
  },
  methods: {
      updateInfo: function( ) {
        if( this.infopointId != null && !isNaN(this.infopointId)  ) {
            var ip = this.$store.getters['infopoint/getInfopointById'](this.infopointId);
            if( ip != null ) {
                this.id = ip.id;
                this.name = ip.name;
                this.uniqueId = ip.uniqueId;
            }
        } else {
            this.id = "";
            this.name="";
            this.uniqueId = "";
        }
      } 
  } 
};
</script>